import { List, Typography } from "antd";
import { NotificationListItemProps } from ".";
import {
  StyledNotificationDescription,
  StyledNotificationTitle,
  StyledNotifyListItem,
  StyledUnseenIcon,
} from "./index.styled";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import {
  NotificationMessage,
  NotificationLogo,
} from "@lib/components/PageComponents/Notification";
import { useNotification } from "@lib/hooks/useNotification";
import { useTypedSelector } from "@lib/redux";

export default function ScannedTransactionFound(
  props: NotificationListItemProps,
) {
  const { notification } = props;
  const { messages } = useIntl();
  const { role } = useTypedSelector((state) => state.auth?.user);
  const { handleClick } = useNotification({
    role,
    initialNotification: notification,
    messages,
  });

  return (
    <StyledNotifyListItem className="item-hover" onClick={handleClick}>
      <List.Item.Meta
        title={
          <StyledNotificationTitle>
            <FormattedMessage id={`notification.name.${notification.event}`} />
            <small>{dayjs(notification?.createdAt).fromNow()}</small>
          </StyledNotificationTitle>
        }
        description={
          <StyledNotificationDescription>
            <Typography>
              <NotificationMessage notification={notification} />
            </Typography>

            {!notification?.isResolved && <StyledUnseenIcon />}
          </StyledNotificationDescription>
        }
        avatar={<NotificationLogo notification={notification} />}
      />
    </StyledNotifyListItem>
  );
}
